import gql from 'graphql-tag'
import client from '@stores/apollo'
import { BuildingTypeFragment, PageInfoFragment } from '@api/fragments'
import { IBuildingTypeWithCompany, IPageInfo } from '@api/types'

interface Payload {
  data: {
    viewer: {
      company: {
        buildingTypes: {
          counters: { total: number }
          pageInfo: IPageInfo
          edges: { node: IBuildingTypeWithCompany }[]
        }
      }
    }
  }
}

export default function list({
  first,
  where,
  orderBy,
  after,
}: {
  first: number
  where?: any
  orderBy: string
  after?: string | null
}): Promise<{
  counters: { total: number }
  buildingTypes: IBuildingTypeWithCompany[]
  pageInfo: IPageInfo
}> {
  return client.gql.query({ query, variables: { first, where, orderBy, after } }).then(
    ({
      data: {
        viewer: {
          company: {
            buildingTypes: { counters, edges, pageInfo },
          },
        },
      },
    }: Payload) => ({
      counters,
      buildingTypes: edges.map(({ node }: { node: IBuildingTypeWithCompany }) => node),
      pageInfo,
    })
  )
}

const query = gql`
  query buildingTypes(
    $first: Int
    $where: BuildingTypeWhereInput
    $orderBy: BuildingTypeOrderByEnum
  ) {
    viewer {
      company {
        buildingTypes(first: $first, where: $where, orderBy: $orderBy) {
          counters {
            total
          }
          edges {
            node {
              ...BuildingTypeFragment
              company {
                id
              }
            }
          }
          pageInfo {
            ...PageInfoFragment
          }
        }
      }
    }
  }
  ${BuildingTypeFragment}
  ${PageInfoFragment}
`
